module.exports = __webpack_public_path__ + "media/images/element/29-6978547b9195290b68e9f54e7e18905e.svg";